module.exports = __webpack_public_path__ + "static/media/SorryImLate.aa03b45c.mp4";